var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('BlockUI',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoader),expression:"showLoader"}],attrs:{"message":_vm.loaderMessage,"url":_vm.loaderUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }